<template>
	<v-row
		class="align-conten"
		justify="center"
	>
		<v-col
			class="xs"
			sm="8"
			md="8"
			lg="8"
		>
			<v-row>
				<v-col>
					<v-card class="elevation-12">
						<v-toolbar
							dark
							color="primary"
						>
							<v-toolbar-title>התחברות</v-toolbar-title>
							<v-spacer />
						</v-toolbar>
						<row class="text-center">
							<c-col class="pa-10">
								<login-form :redirect="{name: 'clients-view'}"/>
							</c-col>
						</row>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	import LoginForm from "../../components/Auth/LoginForm";
	export default {
		name: "user-login-view",
		components: {LoginForm},
		props: {},
		data: () => ({

		}),
		computed: {},
		methods: {

		},
	};
</script>
